import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@clerk/clerk-react';
import { ClerkSignedIn } from '../clerk-components/index';
import CircularProgress from '@mui/material/CircularProgress';
import { Box } from '@mui/material';

type ProtectedRouteProps = {
  children: React.ReactNode; // Type for children
};

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }: ProtectedRouteProps) => {
  const { isSignedIn, isLoaded } = useAuth();

  if (!isLoaded) {
    return (
      <Box
        style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}
      >
        <CircularProgress color='primary' size={50} />
      </Box>
    );
  }

  // Redirect to login page if not signed in
  if (!isSignedIn) {
    return <Navigate to='/login' replace />;
  }

  return <ClerkSignedIn>{children}</ClerkSignedIn>;
};

export default ProtectedRoute;
